import { View } from "@/components/ui";
import { Typography } from "../typography";
import { CaretDoubleUp } from "@/components/shared/icons";
import { cn } from "@/lib/utils";

export const BackToTop = ({
  isVisible,
  onScrollToTop,
}: {
  isVisible: boolean;
  onScrollToTop: () => void;
}) => {
  return (
    <View
      className={cn(
        "native:absolute native:left-1/2 native:-translate-x-1/2 sticky bottom-32 z-10 max-w-[144px] transform web:ml-[50%] web:-translate-x-1/2 md:bottom-8",
        {
          hidden: !isVisible,
        },
      )}
    >
      <View className="flex items-center justify-center">
        <View
          className="flex cursor-pointer flex-row items-center gap-2 rounded-full border border-background-attenuated bg-white px-4 py-2"
          onClick={onScrollToTop}
        >
          <Typography variant="body-sm">Back to Top</Typography>
          <CaretDoubleUp className="text-foreground-intermediate" />
        </View>
      </View>
    </View>
  );
};
